import { render, staticRenderFns } from "./msgtypeLocation.vue?vue&type=template&id=446c9f92&scoped=true&"
import script from "./msgtypeLocation.vue?vue&type=script&lang=js&"
export * from "./msgtypeLocation.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeLocation.vue?vue&type=style&index=0&id=446c9f92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446c9f92",
  null
  
)

export default component.exports